require("dotenv").config();
var axios = require("axios");
var async = require("async");
var auth = require("./auth");

function floopbackRelation(
  model,
  modelRelationMapping,
  nameRelation,
  idArrayRelations
) {
  this.model = model;
  this.modelRelationMapping = modelRelationMapping;
  this.nameRelation = nameRelation;
  this.idArrayRelations = JSON.parse(JSON.stringify(idArrayRelations));
}

floopbackRelation.prototype.save = function(idRelation, nameForeign, objectRelation) {
  let _this = this;
  return new Promise(function(resolve, reject) {
    console.log("_this.idArrayRelations", _this.idArrayRelations);

    var urlDelete =
      process.env.REACT_APP_URL_API +
      "/api/" +
      _this.model +
      "/" +
      idRelation +
      "/" +
      _this.nameRelation;
    var urlCreateMap =
      process.env.REACT_APP_URL_API + "/api/" + _this.modelRelationMapping;
    axios.delete(urlDelete).then(function(result) {

      async.each(_this.idArrayRelations, function (idForeign, callback ) {
        var body = {...objectRelation, [nameForeign]: idForeign}
        axios.post(urlCreateMap, body).then(function(result) {
          callback();
        });
      }, function () {
        resolve(result.data);
      })

    });
  });
};

module.exports = floopbackRelation;



// WEBPACK FOOTER //
// ./src/lib/floopbackRelations.js